<template>
  <card title="Company Details">
    <text-input title="Invoice Address" v-model="companyDetails.address" :multiline="true"/>
    <text-input title="Company Registration #" v-model="companyDetails.registrationNumber" :multiline="false"/>
    <text-input title="VAT #" v-model="companyDetails.VAT" :multiline="false"/>
  </card>
</template>

<script>
export default {
  props: ['companyDetails'],
  components: {
    Card: () => import('@/components/common/Card.vue'),
    TextInput: () => import('@/components/common/TextInput.vue')
  }
}
</script>
